import type CycleModel from '../../../models/CycleModel';
import { requestAndParse, requestSuccessful } from '../request';

const getParticipantCycles = async (participantId: number) => {
    const route = 'admin/get-participant-cycles';
    const payload = { participantId };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const cycles = (response.body?.cycles ?? []) as CycleModel[];

    return { success, cycles };
};

export default getParticipantCycles;
